/* eslint-disable eqeqeq */
import React, { Component, useRef, useEffect } from "react";
import { FaArrowLeft, FaArrowRight, FaBars, FaSearch } from "react-icons/fa";
import {
  Row,
  Col,
  Card,
  message,
  Tabs,
  Modal,
  Menu,
  Icon,
  Dropdown,
} from "antd";
import { Badge } from "antd";
import {
  MdFiberNew,
  MdLanguage,
  MdOutlineOnlinePrediction,
} from "react-icons/md";
import { posStorageAction } from "../../redux/actions/posStorageAction";
import { FaUserClock } from "react-icons/fa";
import { TbShoppingBagDiscount } from "react-icons/tb";
import { GiSplitCross } from "react-icons/gi";
import { GiFallingOvoid } from "react-icons/gi";
import { CiViewList } from "react-icons/ci";
import { HiReceiptRefund } from "react-icons/hi";
import { connect } from "react-redux";
import { FaArrowRotateLeft, FaBarsProgress } from "react-icons/fa6";
import { IoMdClose, IoMdSettings } from "react-icons/io";
import Slider from "react-slick";
import axios from "axios";
import API_URL from "../../constants/API_URL";
import CustomerSelect from "../POS/CustomerSelect";
import Payment from "../POS/Payment";
import MyImg from "../POS/MyImg";
import PosSlip from "./Poslip";
import "./test.css";
import "./PosChildContainer.css";
import { Link } from "react-router-dom";
import { BsFullscreenExit, BsWrenchAdjustable } from "react-icons/bs";
import Swal from "sweetalert2";
import { clear } from "idb-keyval";
import PosKeyboard from "./PosKeyboard/PosKeyboard";
import { IoArrowUndoOutline } from "react-icons/io5";
const dbName = "Injaz Sytems";

const OutsideClickDetector = ({ children, onOutsideClick }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onOutsideClick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onOutsideClick]);

  return <div ref={wrapperRef}>{children}</div>;
};

const { TabPane } = Tabs;
const initialState = {
  productList: [],
  catTabKey: 1,
  catTabKeyWithDelay: 1,
  productLista: [],
  productCategoryList1: [],
  productCategoryList2: [],
  productCategoryList: [],
  comboCategotyList: [],
  comboDetailOption: [],
  selectedCombo: {},
  cardLoad: true,
  arrayAddedItems: [],
  order: {},
  customers: [],
  customerSelect: false,
  customerSelectedName: "Select Customer",
  customerSelected: "",
  isSelected: false,
  posProductsLists: [],
  orderById: {},
  payment: false,
  ccurrent: 1,
  current: 1,
  totalPageItem: 1,
  ctotalPageItem: 1,
  totalProducts: "",
  thiss: this,
  activeCat: "",
  showSendToKitchenButton: false,
  displaytype: "tiny",
  filterdata: false,
  searchval: "",
  setcat: "",
  setuser: "",
  showsearchmodel: false,
  getnumber: "",
  userdataobj: {},
  tableno: "",
  toogle: false,
  toggleNavPhone: false,
  colorLocation: "",
  fontLocation: "",
  branchDetails: {},
};

class Pos2ChildContainer extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.refPosSlip = React.createRef();
    this.focus = this.focus.bind(this);
    this.functionsecRef = React.createRef();
  }
  handlechangeColorLocation = (e) => {
    this.setState({ colorLocation: e.target.id });
    document.body.className = this.state.fontLocation + " " + e.target.id;
    localStorage.setItem(
      "themelocation",
      this.state.fontLocation + " " + e.target.id,
    );
  };
  handlechangeFontLocation = (e) => {
    this.setState({ fontLocation: e.target.id });
    document.body.className = this.state.colorLocation + " " + e.target.id;
    localStorage.setItem(
      "themelocation",
      this.state.colorLocation + " " + e.target.id,
    );
  };
  handlechangeFntSizeLocation = (e) => {
    const fontSize = e.target.value;
    localStorage.setItem("fontSize", fontSize);
    this.applyFontSize(fontSize);
  };

  applyFontSize = (size) => {
    document.body.style.fontSize = size + "px";
    document.querySelectorAll("body *").forEach((item) => {
      item.style.fontSize = size + "px";
    });
  };
  handlechangeFntColsProducts = (e) => {
    let wrapProdcutsSm = document.querySelector(".products .small");
    if (wrapProdcutsSm) {
      wrapProdcutsSm.style.gridTemplateColumns = `repeat(auto-fill, minmax(${e.target.value}px, 1fr))`;
    }
  };
  handlechangeFntRowsProducts = (e) => {
    let wrapProdcutsSm = [
      ...document.querySelectorAll(".products .small .product"),
    ];
    if (wrapProdcutsSm[0]) {
      wrapProdcutsSm.forEach(
        (item) => (item.style.height = e.target.value + "px"),
      );
    }
  };
  handleResteOptionslocation = (e) => {
    let wrapProdcutsSm = document.querySelector(".products .small");
    let prodcutsSm = [
      ...document.querySelectorAll(".products .small .product"),
    ];
    [...document.querySelectorAll("body *")].forEach((item) => {
      item.style.fontSize = "14px";
    });
    localStorage.removeItem("fontSize");
    document.querySelector(".controleFontsize").value = 16;
    document.body.className = "";
    if (prodcutsSm[0] && wrapProdcutsSm) {
      prodcutsSm.forEach((item) => (item.style.height = "180px"));
      wrapProdcutsSm.style.gridTemplateColumns = `repeat(auto-fill, minmax(180px, 1fr))`;
    }
    setTimeout(() => window.location.reload(), 100);
  };
  focus() {
    setTimeout(() => {
      this.textInput.focus();
    }, 800);
  }
  paymentScreen = () => {
    let b = localStorage.getItem(`${this.props.tablenemeprop}`);
    this.props.paymentScreen(b);
  };
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.number === nextProps.number) {
      return true;
    } else {
      return true;
    }
  }
  componentDidMount() {
    const savedFontSize = localStorage.getItem("fontSize");
    if (savedFontSize) {
      setTimeout(() => {
        this.applyFontSize(savedFontSize);
        const fontSizeInput = document.querySelector(".controleFontsize");
        if (fontSizeInput) {
          fontSizeInput.value = savedFontSize;
        }
      }, 1000);
    }
    this.props.hideheader();
    this.getsaleOrderLine();
    this.getProducts();
    this.getCategories();
    this.getComboCategories();
    let displaytype = localStorage.getItem("displaytype") || "tiny";
    this.setState({
      displaytype: displaytype,
    });
    this.getBranchbyIdData(
      JSON.parse(localStorage.getItem("userData")).branchId,
    )
      .then((branchRes) => {
        this.setState({
          branchDetails: branchRes,
        });
      })
      .catch(() => {});

    let a = {
      method: "GET",
      url: API_URL + "clientByID",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    };
    axios(a)
      .then((res) => {
        localStorage.setItem("client_name", res.data.object.name);
      })
      .catch((err) => {});
  }
  conChange = (page) => {
    this.setState({
      ccurrent: page,
      cardLoad2: true,
    });
    this.getCategories({ page: page });
  };
  onChangee = (page) => {
    this.setState({
      current: page,
      cardLoad: true,
    });
    this.fetch({ page: page });
  };
  getComboCategories = () => {
    let accessTokenn = localStorage.getItem("accessToken");
    let tokenTypen = localStorage.getItem("tokenType");
    axios({
      url: API_URL + "posComboList",
      method: "GET",
      params: {
        clientId: localStorage.getItem("clientId"),
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenTypen + " " + accessTokenn,
        "Content-Type": "application/json",
      },
    }).then((res) => {
      this.setState({
        comboCategotyList: res.data,
      });
    });
  };
  getCategories = () => {
    let accessTokenn = localStorage.getItem("accessToken");
    let tokenTypen = localStorage.getItem("tokenType");
    axios({
      url: API_URL + "posCategoryListByTerminal",
      method: "GET",
      params: {
        posTerminalId: JSON.parse(localStorage.getItem("userData"))
          .posTerminalId,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization: tokenTypen + " " + accessTokenn,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        let ar1 = res.data.slice(0, Math.round(res.data.length / 2));
        let ar2 = res.data.slice(Math.round(res.data.length / 2));

        //////////INDEXED DB////////////
        var request = indexedDB.open(dbName, 3);

        request.onerror = function(event) {
          // Handle errors.
        };
        const customerData = [...res.data];
        request.onupgradeneeded = function(event) {
          var db = event.target.result;
          var objectStore = db.createObjectStore("productCategoryList", {
            keyPath: "id",
          });
          objectStore.transaction.oncomplete = function(event) {
            var customerObjectStore = db
              .transaction("productCategoryList", "readwrite")
              .objectStore("productCategoryList");
            customerData.forEach(function(categories) {
              customerObjectStore.add(categories);
            });
          };
        };
        //////////INDEXED DB////////////
        this.setState({
          productCategoryList: res.data,
          productCategoryList1: ar1,
          productCategoryList2: ar2,
        });
      })
      .catch((err) => {
        this.productCategoryListWhenOffline(dbName);
      });
  };
  productCategoryListWhenOffline = (dbName, productCategoryList) => {
    //////////INDEXED DB////////////
    const self = this;
    var DBOpenRequest = window.indexedDB.open(dbName);
    DBOpenRequest.onsuccess = function(event) {
      // store the result of opening the database in the db variable.
      // This is used a lot below
      var db = DBOpenRequest.result;
      var transaction = db.transaction(["productCategoryList"], "readwrite");
      var objectStore = transaction.objectStore("productCategoryList");
      var objectStoreRequest = objectStore.getAll();

      objectStoreRequest.onsuccess = function(event) {
        // report the success of our request
        var myRecord = objectStoreRequest.result;
        self.setState({ productCategoryList: myRecord, cardLoad: false });
      };
    };
    //////////INDEXED DB////////////
  };

  categorySelected = (e) => {
    if (e.name.toLowerCase() == "combo") {
      this.comboSelected(e);
    } else {
      this.getProductsByCategory(e);
    }
  };
  comboSelected = (e) => {
    let catTabKeyWithDelay = 2;
    this.setState({
      productList: this.state.comboCategotyList,
      cardLoad: false,
      activeCat: e.id,
      catTabKeyWithDelay,
    });
  };
  getcomboDetailsbyCombo = (e) => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    axios({
      url: API_URL + "comboOptionDetailsByCombo",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        comboId: e.id,
        lang,
      },
    }).then((result) => {
      this.setState(
        { comboDetailOption: result.data, selectedCombo: e },
        () => {
          // Modal Open For Selecting Combo Deals Products
          this.refPosSlip.comboProductsModalOpenFunction();
        },
      );
    });
  };
  getProductsByCategory = (e) => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    axios({
      url: API_URL + "posProductsListByCategory",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        categoryId: e.id,
        branchId: JSON.parse(localStorage.getItem("userData")).branchId,
        lang,
        customerId: this.props.posStorage.customer,
      },
    })
      .then((result) => {
        let catTabKeyWithDelay = this.state.catTabKey;

        this.setState({
          catTabKeyWithDelay,
          productList: result.data,
          cardLoad: false,
          activeCat: e.id,
        });
      })
      .catch((err) => {
        this.setState({
          productList: this.state.productLista.filter(
            (item) => item.categoryId === e.id,
          ),
          cardLoad: false,
          activeCat: e.id,
        });
      });
  };
  //sercahProdList?q=piz
  getProducts = () => {
    let lang = localStorage.getItem("lang");
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    let clientId = localStorage.getItem("clientId");
    axios({
      url: API_URL + "posProductsList",
      method: "GET",
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
      params: {
        clientId,
        lang,
      },
    })
      .then((result) => {
        this.setState({ productLista: result.data, cardLoad: false });

        //////////INDEXED DB////////////
        var request = indexedDB.open(dbName, 2);

        request.onerror = function(event) {};
        const customerData = [...result.data];
        request.onupgradeneeded = function(event) {
          var db = event.target.result;
          var objectStore = db.createObjectStore("posProductsList", {
            keyPath: "id",
          });
          objectStore.transaction.oncomplete = function(event) {
            var customerObjectStore = db
              .transaction("posProductsList", "readwrite")
              .objectStore("posProductsList");
            customerData.forEach(function(categories) {
              customerObjectStore.add(categories);
            });
          };
        };
      })
      .catch((err) => {
        this.posProductsListWhenOffline(dbName);
      });
  };
  posProductsListWhenOffline = (dbName) => {
    //////////INDEXED DB////////////
    const self = this;
    var DBOpenRequest = window.indexedDB.open(dbName);
    DBOpenRequest.onsuccess = function(event) {
      // store the result of opening the database in the db variable.
      // This is used a lot below
      var db = DBOpenRequest.result;
      var transaction = db.transaction(["posProductsList"], "readwrite");
      var objectStore = transaction.objectStore("posProductsList");
      var objectStoreRequest = objectStore.getAll();

      objectStoreRequest.onsuccess = function(event) {
        // report the success of our request
        var myRecord = objectStoreRequest.result;
        self.setState({ productLista: myRecord });
      };
    };
    //////////INDEXED DB////////////
  };
  onCustomerSelect = (v) => {
    let thiss = this.props;
    this.setState(
      {
        customerSelected: v.customerSelected,
        customerSelectedName: v.customerSelectedName,
        customerSelect: false,
        isSelected: v.isSelected,
      },
      () => {
        this.createSaleOrder(v.customerSelected);
        thiss.showButtos();
      },
    );
  };
  createSaleOrder = (v) => {
    axios({
      method: "GET",
      url: API_URL + "saleOrderByID",
      params: {
        // id: JSON.parse(localStorage.getItem('posStorage')).orderId,
        id: this.props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      this.props.saleOrderByIDFunction();

      axios({
        url: API_URL + "updateSaleOrder",
        method: "POST",
        data: {
          lang: localStorage.getItem("lang"),
          customer: v,
          id: res.data.object.id,
          notes: res.data.object.notes,
          orderType: res.data.object.orderType,
          payMethod: res.data.object.payMethod,
          priceWithoutTax: res.data.object.priceWithoutTax,
          warehouse: res.data.object.warehouse,
          flrTable: res.data.object.flrTable,
          priority: res.data.object.priority,
          extraNotes: res.data.object.extraNotes,
          cashier: JSON.parse(localStorage.getItem("userData")).userId,
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      })
        .then(async (ress) => {
          if (ress.data.success) {
            // message.success(ress.data.message)
            let posStorage = {
              customer: v,
              customerName: this.state.customerSelectedName,
              orderId: this.props.posStorage.orderId,
              floorId: this.props.posStorage.floorId,
              pos: this.props.posStorage.pos,
              // orderId: JSON.parse(localStorage.getItem('posStorage')).orderId,
              // floorId: JSON.parse(localStorage.getItem('posStorage')).floorId,
              // pos: JSON.parse(localStorage.getItem('posStorage')).pos
            };
            await this.props.posStorageAction(posStorage);
            // await localStorage.setItem('posStorage', JSON.stringify(posStorage))
            this.props.getUpdateAboutCustomer();
          } else {
            message.error(ress.data.message);
          }
        })
        .catch((err) => {});
    });
  };
  addProduct = (item) => {
    if (
      this.state.orderById.isMinCharge &&
      this.state.orderById.chargeType == "P" &&
      this.state.orderById.noOfGuest <= 0
    ) {
      message.error("Please select number of guest before adding products.");
      this.props.guest();
      return;
    }
    if (
      this.state.orderById.status == "C" ||
      this.state.orderById.status == "P"
    ) {
      return false;
    }
    if (this.state.catTabKeyWithDelay == 2) {
      this.getcomboDetailsbyCombo(item);
      return false;
    }
    let data = {
      lang: localStorage.getItem("lang"),
      client: localStorage.getItem("clientId"),
      // order: JSON.parse(localStorage.getItem('posStorage')).orderId,
      order: this.props.posStorage.orderId,
      product: item.id,
      isScaleProduct: item.isScaleProduct,
      qty: 1,
      uom: item.uomId,
      isGroupProduct: item.isGroupProduct,
      priceWithoutTax: item.priceWithoutTax,
      unitPrice: item.price,
      isOffer: item.isOffer,
      prodOffer: item.offerId,
      offerType: item.offerType,
    };
    if (item.isOffer) {
      data.unitPrice = item.offerPriceTax;
    }
    if (item.isGroupProduct) {
      data.isGroupProduct = true;
      data.isAddProduct = false;
      data.min = item.minItemQty;
      data.max = item.maxItemQty;
    } else {
      data.isGroupProduct = false;
      data.isAddProduct = false;
    }
    this.refPosSlip.showModalOnAddItem(data, item.isGroupProduct);
  };
  getsaleOrderLine = () => {
    let authOptions = {
      url: API_URL + "saleOrderLinesByOrder",
      method: "POST",
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
      data: {
        lang: localStorage.getItem("lang"),
        clientId: localStorage.getItem("clientId"),
        // order: JSON.parse(localStorage.getItem('posStorage')).orderId,
        order: this.props.posStorage.orderId,
        sortOrder: "ASC",
        sortColumn: "lineno",
        page: 0,
        size: 50,
      },
    };
    axios(authOptions)
      .then((res) => {
        let a = res.data.content.filter((item) => item.status == "DR").length;
        let showSendToKitchenButton = a > 0 ? true : false;
        this.setState(
          {
            showSendToKitchenButton,
            posProductsLists: res.data.content,
            arrayAddedItems: res.data.content,
          },
          () => {
            this.saleOrderByID(null, true);
          },
        );
        setTimeout(() => {
          this.props.updateSatte();
        }, 600);
      })
      .catch((err) => {
        this.setState({
          posProductsLists: [],
          arrayAddedItems: [],
        });
      });
  };
  customerSelect = () => {
    this.setState({ customerSelect: true, showsearchmodel: false });
  };

  onBack = () => {
    this.props.showButtos();
    this.setState({ customerSelect: false });
  };
  saleOrderByID = (a) => {
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let data = {
      lang: localStorage.getItem("lang"),
      // id: JSON.parse(localStorage.getItem('posStorage')).orderId
      id: this.props.posStorage.orderId,
    };
    let authOptions = {
      url: API_URL + "saleOrderByID",
      method: "GET",
      params: data,
      headers,
    };
    axios(authOptions).then((res) => {
      this.props.saleOrderByIDFunction(false);
      this.setState({ orderById: res.data.object });
    });
  };

  onpaymentReset = async () => {
    this.setState(initialState, () => {
      this.getsaleOrderLine();
      this.getProducts();
      this.getCategories();
      this.getComboCategories();
      let a = {
        method: "GET",
        url: API_URL + "clientByID",
        params: {
          clientId: localStorage.getItem("clientId"),
          lang: localStorage.getItem("lang"),
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      };
      axios(a)
        .then((res) => {
          localStorage.setItem("client_name", res.data.object.name);
        })
        .catch((err) => {});
    });
    this.refPosSlip.myRset();
    this.props.resetStateOnPayment();
  };
  onPaymentSelect = () => {
    this.state.payment && this.props.showButtos();
    this.setState({ payment: !this.state.payment });
  };
  showAlert(a) {
    this.refPosSlip.showModal(a);
  }
  getBranchbyIdData = (id) => {
    return new Promise((resolve, reject) => {
      let a = {
        method: "GET",
        url: API_URL + "branchByID",
        params: {
          id: id,
          lang: localStorage.getItem("lang"),
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      };
      axios(a)
        .then((res) => {
          resolve(res.data.object);
        })
        .catch((err) => reject(err));
    });
  };
  state = {
    show: "false",
  };
  setnumber = (e) => {
    this.setState({ getnumber: e.target.value });
  };

  handleChangeLanguage = (languageToChange) => {
    Swal.fire({
      title: "تغيير اللغة",
      text: "يرجى اختيار لغتك المفضلة",
      icon: "question",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "العربية",
      denyButtonText: "English",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.setItem("lang", "AR");
        window.location.reload();
      } else if (result.isDenied) {
        localStorage.setItem("lang", "EN");
        window.location.reload();
      }
    });
  };
  scrollLeft = () => {
    const container = this.functionsecRef.current;
    if (container) {
      container.scrollTo({
        left: container.scrollLeft - 200, // 200px كل مرة
        behavior: "smooth",
      });
    }
  };

  // التمرير لليمين
  scrollRight = () => {
    const container = this.functionsecRef.current;
    if (container) {
      container.scrollTo({
        left: container.scrollLeft + 200,
        behavior: "smooth",
      });
    }
  };
  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      autoplaySpeed: 2000,

      pauseOnHover: true,

      responsive: [
        {
          breakpoint: 1184,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    let showlist = () => {
      this.setState({
        show: !this.state.show,
      });
    };
    let dsmall = (props) => {
      localStorage.setItem("displaytype", props);
      this.setState({
        displaytype: props,
        show: "false",
      });
    };
    // filterdata: 'false',
    //   searchval: ''

    let handleChange = (event) => {
      if (event.target.value.length > 3) {
        this.setState({
          searchval: event.target.value,
          filterdata: true,
        });

        let accessToken = localStorage.getItem("accessToken");
        let tokenType = localStorage.getItem("tokenType");
        let clientId = localStorage.getItem("clientId");
        axios({
          url:
            API_URL +
            "productByBarcodeOrName?clientId=983e1aa5-004d-4543-9039-f0137fd636ef&barcodeOrName=" +
            event.target.value,
          method: "GET",
          headers: {
            Authorization: tokenType + " " + accessToken,
            "Content-Type": "application/json",
          },
        }).then((res) => {
          this.setState({
            productList: res.data,
          });
        });
      }
    };

    function matchString() {
      // var string = "Welcome to geeks for geeks";
      // var result = string.match(/eek/g);
      // document.write("Output : " + result);
    }

    const handleOutsideClick = (v) => {
      document.getElementsByClassName(
        "tabimg1",
      )[0].childNodes[1].style.display = "";
    };
    const showOptionHandler = (v) => {
      // let thiss = this.props;
      // this.setState(
      //   () => {
      //     thiss.showOptionModal();
      //   }
      // );
      document.getElementsByClassName(
        "tabimg1",
      )[0].childNodes[1].style.display = "block";
    };
    let kitchenhandler = () => {
      this.props.kitchen();
      // document.getElementById('kitchen')?.style?.display = 'block'
    };

    // Othman [OTP]
    let CheckCustomers = () => {
      let data = {
        lang: "en",
        clientId: localStorage.getItem("clientId"),
        page: 0,
        size: 10,
        name: "",
        phoneNo: this.state.getnumber,
        email: "",
        building: "",
        street: "",
        flatNo: "",
        landmark: "",
        sortOrder: "DESC",
      };

      axios({
        url: API_URL + "customersByClient",
        method: "POST",
        data,
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      }).then((resp) => {
        if (resp.data.totalElements > 0) {
          this.setState({
            userdataobj: resp.data.content[0],
            setuser: resp.data.content[0],
            // showsearchmodel: false,
            // toogle: !this.state.toogle,
          });
          localStorage.setItem("setusername", `${this.state.userdataobj.name}`);
          localStorage.setItem(
            `${this.props.tablenemeprop}`,
            `${resp.data.content[0].name}`,
          );
          // this.props.setuserdata(this.props.tablenemeprop);

          const dataSendOtp = {
            orderId: this.props.posStorage.orderId,
            customerId: resp.data.content[0].id,
          };
          axios({
            url: API_URL + "set-order-otp",
            method: "POST",
            params: dataSendOtp,
          })
            .then((resOtp) => {
              Swal.fire({
                title: "Send OTP Success, Enter OTP",
                input: "text",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: "Submit",
                showLoaderOnConfirm: true,
              }).then((resSwal) => {
                if (resSwal.isConfirmed) {
                  axios({
                    method: "GET",
                    url: API_URL + "saleOrderByID",
                    params: {
                      id: this.props.posStorage.orderId,
                      lang: localStorage.getItem("lang"),
                    },
                    headers: {
                      Authorization:
                        localStorage.getItem("tokenType") +
                        " " +
                        localStorage.getItem("accessToken"),
                      "Content-Type": "application/json",
                    },
                  }).then((res) => {
                    this.props.saleOrderByIDFunction();
                    const v = resp.data.content[0].id;
                    axios({
                      url: API_URL + "updateSaleOrder",
                      method: "POST",
                      data: {
                        lang: localStorage.getItem("lang"),
                        customer: v,
                        id: res.data.object.id,
                        otp: resSwal.value,
                        notes: res.data.object.notes,
                        orderType: res.data.object.orderType,
                        payMethod: res.data.object.payMethod,
                        priceWithoutTax: res.data.object.priceWithoutTax,
                        warehouse: res.data.object.warehouse,
                        flrTable: res.data.object.flrTable,
                        priority: res.data.object.priority,
                        extraNotes: res.data.object.extraNotes,
                        cashier: JSON.parse(localStorage.getItem("userData"))
                          .userId,
                      },
                      headers: {
                        Authorization:
                          localStorage.getItem("tokenType") +
                          " " +
                          localStorage.getItem("accessToken"),
                        "Content-Type": "application/json",
                      },
                    })
                      .then(async (ress) => {
                        if (ress.data.success) {
                          // message.success(ress.data.message)
                          let posStorage = {
                            customer: v,
                            customerName: this.state.customerSelectedName,
                            orderId: this.props.posStorage.orderId,
                            floorId: this.props.posStorage.floorId,
                            pos: this.props.posStorage.pos,
                            // orderId: JSON.parse(localStorage.getItem('posStorage')).orderId,
                            // floorId: JSON.parse(localStorage.getItem('posStorage')).floorId,
                            // pos: JSON.parse(localStorage.getItem('posStorage')).pos
                          };
                          await this.props.posStorageAction(posStorage);
                          // await localStorage.setItem('posStorage', JSON.stringify(posStorage))
                          this.props.getUpdateAboutCustomer();

                          this.props.onUpdate(this.props.tablenemeprop);
                          this.setState({
                            showsearchmodel: false,
                            toogle: !this.state.toogle,
                          });
                          Swal.fire({
                            title: "Successfully",
                            text: "Order Updated Successfully",
                            icon: "success",
                          });
                        } else {
                          message.error(ress.data.message);
                          Swal.fire({
                            title: "Error OTP",
                            text: "Invalid Order OTP",
                            icon: "error",
                          });
                        }
                      })
                      .catch((err) => {
                        Swal.fire({
                          title: "Error OTP",
                          text: "Invalid Order OTP",
                          icon: "error",
                        });
                      });
                  });
                }
                // this.createSaleOrder(resp.data.content[0].id);
              });
            })
            .catch((err) => {
              console.log(err);
              Swal.fire({
                title: "Error Send OTP",
                text: "Please try again",
                icon: "error",
              });
            });
        } else {
          localStorage.setItem(
            "phonenumberforadduser",
            `${this.state.getnumber}`,
          );
          this.customerSelect();
        }
      });
    };

    let voldtab = () => {
      // release & void working

      this.props.voidorder();

      setTimeout(() => {
        this.props.posStorageAction({ pos: false });
        this.props.showheader();
        localStorage.removeItem(`${this.props.tablenemeprop}`);
      }, 300);
      this.setState({ pos: false }, () => {
        this.props.onComponentDidMountRender();
      });
    };

    this.lang = this.props.language.INJAZ_POS_POS_SCREEN;

    return (
      <React.Fragment>
        {this.state.customerSelect ? (
          <CustomerSelect
            language={this.props.props}
            onBack={this.onBack}
            onCustomerSelect={this.onCustomerSelect}
            visible={true}
            numval={localStorage.getItem("phonenumberforadduser")}
            tablenop={this.props.tablenemeprop}
          />
        ) : this.state.payment && false ? (
          <Payment
            printCall={(v, cashPaidAmount) => {
              this.props.buildMessage1("payment", v, cashPaidAmount);
              this.getBranchbyIdData(
                JSON.parse(localStorage.getItem("userData")).branchId,
              ).then((res) => {
                if (res.isPrntKitPayComp) {
                  this.props.printInKitchen();
                }
              });
            }}
            onPaymentSelect={this.onPaymentSelect}
            state={this.state}
            {...this.props}
          />
        ) : (
          <React.Fragment>
            {/* mywork */}
            <div className="pos-nav">
              <div className="wrapper-nav customtableheader">
                {this.state.showsearchmodel && (
                  <Modal
                    className="posAddItemModal product-modal-pop extended-width sadi1"
                    visible={this.state.showsearchmodel}
                    onCancel={() => this.setState({ showsearchmodel: false })}
                    onOk={() => this.handleOk1stModal(true)}
                    headers={false}
                    footer={false}
                    style={{ direction: this.props.lang.INJAZ_AUTH_DIRECTION }}
                  >
                    <div className="popupphonemodal">
                      <div className="searchbox">
                        <h1>
                          {this.lang.PLEASE_ADD_CUSTOMER_PHONE ||
                            "Please Add Customer Phone No:"}
                        </h1>
                        <span className="inp">
                          <p>{this.lang.PHONE_NO || "Phone No:"}</p>
                          <input
                            ref={(input) => {
                              this.textInput = input;
                            }}
                            onChange={this.setnumber.bind(this)}
                          />
                        </span>
                        <button onClick={CheckCustomers}>
                          {this.lang.CHECK || "Check"}
                        </button>
                      </div>
                    </div>
                  </Modal>
                )}
                <div
                  style={{ direction: this.lang.INJAZ_AUTH_DIRECTION }}
                  className="left"
                >
                  <div className="foodlocationimg">
                    <MyImg
                      src="/logoMain.png"
                      alt={this.lang.LOGO_ALT || "logo"}
                    />
                  </div>
                  <div
                    className={`menuSetting ${
                      this.state.menuSetting ? "active" : ""
                    }`}
                  >
                    <div
                      className="overlaySetting"
                      onClick={(e) => this.setState({ menuSetting: false })}
                    ></div>
                    <div className="contetn">
                      <div className="controleTheme">
                        {localStorage.getItem("darkTheme") ? (
                          localStorage.getItem("darkTheme") == "true" ? (
                            <button
                              className="link-button black-text-color"
                              onClick={() => {
                                localStorage.setItem("darkTheme", false);
                                window.location.reload();
                              }}
                              rel="noopener noreferrer"
                            >
                              <Icon
                                type="bg-colors"
                                theme="outlined"
                                className="dropdown-icon link-button black-text-color  "
                              />
                              {this.lang.LIGHT_THEME || "Light Theme"}
                            </button>
                          ) : (
                            <button
                              className="link-button black-text-color"
                              onClick={() => {
                                localStorage.setItem("darkTheme", true);
                                window.location.reload();
                              }}
                              rel="noopener noreferrer"
                            >
                              <Icon
                                type="bg-colors"
                                theme="outlined"
                                className="dropdown-icon link-button black-text-color "
                              />
                              {this.lang.DARK_THEME || "Dark Theme"}
                            </button>
                          )
                        ) : (
                          <button
                            className="link-button black-text-color"
                            onClick={() => {
                              localStorage.setItem("darkTheme", true);
                              window.location.reload();
                            }}
                            rel="noopener noreferrer"
                          >
                            <Icon
                              type="bg-colors"
                              theme="outlined"
                              className="dropdown-icon link-button black-text-color "
                            />
                            {this.lang.DARK_THEME || "Dark Theme"}
                          </button>
                        )}
                      </div>
                      <div className="logoutBtn">
                        <button
                          className="link-button black-text-color"
                          rel="noopener noreferrer"
                          onClick={this.handleChangeLanguage}
                        >
                          <Icon
                            type="global"
                            theme="outlined"
                            className="dropdown-icon link-button black-text-color"
                          />
                          {this.lang.SWITCH_LANGUAGE || "Switch Language"}
                        </button>
                      </div>
                      <div
                        className="logoutBtn"
                        onClick={() => {
                          let newObj = {
                            ...JSON.parse(localStorage.getItem("persist:root")),
                          };
                          newObj.user = {};
                          newObj.clientById = {};
                          newObj.parametersListByParaType = {};
                          localStorage.clear();
                          try {
                            clear();
                          } catch {}
                          window.location.reload();
                        }}
                      >
                        <button
                          className="link-button black-text-color"
                          rel="noopener noreferrer"
                        >
                          <Icon
                            type="logout"
                            theme="outlined"
                            className="dropdown-icon  link-button black-text-color "
                          />
                          {this.lang.LOGOUT || "Logout"}
                        </button>
                      </div>
                      <ul className="colorLocation">
                        <p>{this.lang.COLORS || "Colors"}</p>
                        <div className="list">
                          <li
                            id="red"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="yellow"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="green"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="blue"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="gray"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="move"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="classc"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="pink"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="blue2"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="blue3"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                          <li
                            id="black"
                            onClick={(e) => this.handlechangeColorLocation(e)}
                          ></li>
                        </div>
                      </ul>
                      <ul className="fontSizeLocation">
                        <p>{this.lang.FONT_SIZE || "Font Size"}</p>
                        <input
                          className="controleFontsize"
                          step={"any"}
                          defaultValue={16}
                          min={10}
                          max={20}
                          type="range"
                          onChange={(e) => this.handlechangeFntSizeLocation(e)}
                        />
                      </ul>
                      <div>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            style={{
                              flex: "1",
                              borderRadius: "5px",
                              color: "#fff !important",
                            }}
                            className="resteOptionslocation"
                            onClick={(e) => this.handleResteOptionslocation(e)}
                          >
                            <FaArrowRotateLeft color="#fff" />
                          </button>
                          <button
                            style={{
                              flex: "1",
                              borderRadius: "5px",
                              color: "#fff !important",
                            }}
                            className="closeMenuSetting"
                            onClick={(e) =>
                              this.setState({ menuSetting: false })
                            }
                          >
                            {this.lang.CLOSE || "Close"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="btnArrowLeftFunctionsec"
                  onClick={() => this.scrollLeft()}
                >
                  <FaArrowLeft />
                </div>
                <div
                  className={`functionsec ${
                    this.state.toggleNavPhone ? "active" : ""
                  }`}
                  onWheel={(e) => {
                    // e.preventDefault();
                    e.currentTarget.scrollLeft += e.deltaY;
                  }}
                  ref={this.functionsecRef}
                >
                  <i
                    onClick={() => this.setState({ toggleNavPhone: false })}
                    className="close"
                  >
                    <IoMdClose />{" "}
                  </i>
                  <div
                    onClick={(e) =>
                      this.setState({
                        menuSetting: this.state.menuSetting ? false : true,
                      })
                    }
                    className="iconwrapper"
                  >
                    <p>{this.lang.SETTINGS}</p>
                    <i>
                      <IoMdSettings />
                    </i>
                  </div>

                  <Link to={"/dashboard/pos"} className="iconwrapper">
                    <p>{this.lang.BACK_TO_POS || "Back to POS"}</p>
                    <i>
                      <IoArrowUndoOutline />
                    </i>
                  </Link>
                  <div
                    className="iconwrapper"
                    onClick={() => {
                      try {
                        const elem = document.documentElement;
                        if (!document.fullscreenElement) {
                          elem.requestFullscreen().catch((err) => {
                            console.warn(
                              `Error attempting to enable full-screen mode: ${err.message}`,
                            );
                          });
                        } else {
                          document.exitFullscreen();
                        }
                      } catch {}
                    }}
                  >
                    <p>{this.lang.FULL_SCREEN}</p>
                    <i>
                      <BsFullscreenExit />
                    </i>
                  </div>
                  {this.props.saleOrderData.status == "P" ? (
                    <div
                      className="iconwrapper"
                      onClick={() => {
                        if (this.state.branchDetails.refundPassword) {
                          Swal.fire({
                            title:
                              this.lang.PLEASE_ENTER_PASSWORD ||
                              "Please Enter Password",
                            input: "text",
                            inputAttributes: {
                              autocapitalize: "off",
                            },
                            showCancelButton: true,
                            confirmButtonText: this.lang.SUBMIT || "Submit",
                            showLoaderOnConfirm: true,
                          }).then((res) => {
                            if (res.isConfirmed) {
                              if (
                                res.value ===
                                this.state.branchDetails.refundPassword
                              ) {
                                this.props.REFUNDINITIATEfunc();
                              } else {
                                Swal.fire({
                                  title:
                                    this.lang.ERROR_PASSWORD ||
                                    "Error Password!",
                                  text:
                                    this.lang.INVALID_PASSWORD ||
                                    "Invalid Password!",
                                  icon: "error",
                                });
                              }
                            }
                          });
                        } else {
                          this.props.REFUNDINITIATEfunc();
                        }
                      }}
                    >
                      <p>{this.props.REFUNDINITIATE}</p>
                      <i>
                        <HiReceiptRefund />
                      </i>
                    </div>
                  ) : this.props.saleOrderData.status == "RI" ? (
                    <div
                      className="iconwrapper"
                      onClick={() => this.props.REFUNDCOMPLETEfunc()}
                    >
                      <p>{this.props.REFUNDCOMPLETE}</p>
                      <i>
                        <HiReceiptRefund />
                      </i>
                    </div>
                  ) : (
                    ""
                  )}
                  {(this.props.isShowKitchen &&
                    this.props.posStorage.orderId &&
                    this.state.showSendToKitchenButton) ||
                  Number(localStorage.getItem("minChargeAmount")) > 0 ? (
                    <div
                      className="iconwrapper"
                      id="kitchen"
                      onClick={kitchenhandler}
                      style={{
                        pointerEvents: this.props.sendToKitchenBtn
                          ? "none"
                          : "all",
                        opacity: this.props.sendToKitchenBtn ? ".6" : "1",
                      }}
                    >
                      <MyImg src="/icons/kitchen.png" alt="" />
                      <p>
                        {this.props.sendToKitchenBtn
                          ? this.lang.LOADING || "Loading..."
                          : this.lang.KITCHEN || "Kitchen"}
                      </p>
                    </div>
                  ) : (
                    false
                  )}
                  <div
                    className={`iconwrapper ${
                      this.props.online_orders_listShow ? "active2" : ""
                    }`}
                    onClick={this.props.onlineorderpopup}
                  >
                    <div className="countDown">
                      {this.props.no_of_online_orders}
                    </div>
                    <p>{this.lang.ONLINE || "Online"}</p>
                    <i>
                      <MdOutlineOnlinePrediction />
                    </i>
                  </div>

                  <div
                    className={`iconwrapper ${
                      this.props.onlineOrdersListOpens ? "active2" : ""
                    }`}
                    onClick={this.props.orderlist}
                  >
                    <p>{this.lang.ORDER_LIST || "Order List"}</p>
                    <i>
                      <CiViewList />
                    </i>
                  </div>

                  <div
                    className={`iconwrapper ${
                      this.props.discountPopUp ? "active2" : ""
                    }`}
                    onClick={this.props.discount}
                  >
                    <p>{this.lang.DISCOUNT || "Discount"}</p>
                    <i>
                      <TbShoppingBagDiscount />
                    </i>
                  </div>
                  <div
                    className={`iconwrapper ${
                      this.props.newOrderPopup ? "active2" : ""
                    }`}
                    onClick={this.props.newOrderFuc}
                  >
                    <p>{this.lang.NEW || "New"}</p>
                    <i>
                      <MdFiberNew />
                    </i>
                  </div>

                  <div
                    className={`iconwrapper ${
                      this.props.splitOrderVisible ? "active2" : ""
                    }`}
                    onClick={this.props.splitorder}
                  >
                    <p>{this.lang.SPLIT || "Split"}</p>
                    <i>
                      <GiSplitCross />
                    </i>
                  </div>

                  {JSON.parse(localStorage.getItem("userData")).roles.includes(
                    "VOID",
                  ) && (
                    <div
                      className="iconwrapper"
                      onClick={() => {
                        voldtab();
                      }}
                    >
                      <p>{this.lang.VOID || "Void"}</p>
                      <i>
                        <GiFallingOvoid />{" "}
                      </i>
                    </div>
                  )}
                </div>
                <div
                  className="btnArrowRightFunctionsec"
                  onClick={() => this.scrollRight()}
                >
                  <FaArrowRight />
                </div>
              </div>
            </div>
            <div className="customdashboard customdashboardPos2">
              <div className="groub" style={{ display: "none" }}>
                {/* Product Categories Section - Keeping as is since category names come from API */}
                <div className="productcatcont">
                  <div className="wrappCategory">
                    {/* Category items - names come from API, no hardcoded text */}
                  </div>
                  <div className="bars" onClick={showlist}>
                    <i>
                      <BsWrenchAdjustable />
                    </i>
                    <ul
                      className={
                        this.state.show ? "typelists show" : "typelists hide"
                      }
                    >
                      <li
                        onClick={() => {
                          dsmall("tiny");
                        }}
                      >
                        3D
                      </li>
                      <li
                        onClick={() => {
                          dsmall("small");
                        }}
                      >
                        {this.lang.SMALL || "Small"}
                      </li>
                      <li
                        onClick={() => {
                          dsmall("med");
                        }}
                      >
                        {this.lang.MEDIUM || "Medium"}
                      </li>
                      <li
                        onClick={() => {
                          dsmall("large");
                        }}
                      >
                        {this.lang.LARGE || "Large"}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="header-groub">
                  <div className="productheader">
                    <div className="flexi">
                      <FaSearch className="icon" />
                      <input
                        type="text"
                        placeholder={
                          this.lang.SEARCH_PRODUCT || "Search Product"
                        }
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="products">
                  <div className="contwrapper">
                    <div
                      className={
                        this.state.productList.length > 0 &&
                        this.state.displaytype == "tiny"
                          ? "productwrapper tiny"
                          : this.state.productList.length > 0 &&
                            this.state.displaytype == "med"
                          ? "productwrapper med"
                          : this.state.productList.length > 0 &&
                            this.state.displaytype == "large"
                          ? "productwrapper large"
                          : this.state.productList.length > 0 &&
                            this.state.displaytype == "small"
                          ? "productwrapper small"
                          : null
                      }
                    >
                      {/* Product items - names and prices come from API, no hardcoded text */}
                    </div>
                    <div className="tablesec">
                      <OutsideClickDetector onOutsideClick={handleOutsideClick}>
                        {
                          <div className="tabimg1" onClick={showOptionHandler}>
                            <MyImg
                              src="/icons/option.png"
                              alt=""
                              className="imghov"
                            />
                            <ul className="optionlist">
                              {JSON.parse(
                                localStorage.getItem("userData"),
                              ).roles.includes("PRINT_CHECK") &&
                              this.props.saleOrderData.status === "P" ? (
                                <li onClick={this.props.printDuplicate}>
                                  {this.lang.PRINT_INVOICE || "Print invoice"}
                                </li>
                              ) : (
                                <>
                                  {JSON.parse(
                                    localStorage.getItem("userData"),
                                  ).roles.includes("PRINT_CHECK") && (
                                    <li onClick={this.props.print}>
                                      {this.lang.CHECK_PRINT || "Check Print"}
                                    </li>
                                  )}
                                  <li onClick={this.props.guest}>
                                    {this.lang.NO_OF_GUESTS || "No. of Guests"}
                                  </li>
                                  <li onClick={this.props.changetab}>
                                    {this.lang.CHANGE_TABLE || "Change Table"}
                                  </li>
                                  <li onClick={this.props.ordertype}>
                                    {this.lang.ORDER_TYPE || "Order Type"}
                                  </li>
                                </>
                              )}
                            </ul>
                          </div>
                        }
                      </OutsideClickDetector>
                      <div
                        className="tabimg"
                        onClick={() => {
                          this.props.posStorageAction({ pos: false });
                          this.setState({ pos: false }, () => {
                            this.onComponentDidMountRender();
                          });
                          this.props.showheader();
                        }}
                      >
                        <MyImg src="/icons/table.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="payslip">
                {Object.keys(this.state.userdataobj).length > 0 ||
                (localStorage.getItem(`${this.props.tablenemeprop}`) !== "" &&
                  localStorage.getItem(`${this.props.tablenemeprop}`) !==
                    null) ? (
                  <div
                    className="setval"
                    onClick={() => {
                      this.setState({ showsearchmodel: true });
                      this.focus();
                    }}
                  >
                    <i>
                      <FaUserClock />
                    </i>
                    <p>
                      {localStorage.getItem(`${this.props.tablenemeprop}`) ||
                        this.state.userdataobj.name}
                    </p>
                  </div>
                ) : (
                  <div
                    className="setval"
                    onClick={() => {
                      this.setState({ showsearchmodel: true });
                      this.focus();
                    }}
                  >
                    <i>
                      <FaUserClock />
                    </i>
                    <p>{this.lang.WALKIN_CUSTOMER || "Walkin Customer"}</p>
                  </div>
                )}
                <PosSlip
                  paymethods={this.props.paymethods}
                  paymentok={this.props.paymentok}
                  senPrintOnCancelOrder={(i) =>
                    this.props.senPrintOnCancelOrder(i)
                  }
                  isDiscount={this.props.isDiscount}
                  isDiscountP={this.props.isDiscountP}
                  disAmt={this.props.disAmt}
                  disPrctg={this.props.disPrctg}
                  lang={this.props.lang}
                  paymentScreen={() => this.paymentScreen()}
                  EmptyUserObjMain={() => this.EmptyUserObjMain()}
                  ref={(ref) => (this.refPosSlip = ref)}
                  getsaleOrderLine={() => this.getsaleOrderLine()}
                  totalOrder={this.state.orderById}
                  productList={this.state.productLista}
                  posProductsLists={this.state.posProductsLists}
                  customerSelectedName={this.state.customerSelectedName}
                  language={this.props.props.language}
                  customerSelect={() => this.customerSelect()}
                  slipData={this.state.arrayAddedItems}
                  onPaymentSelect={(a) => this.onPaymentSelect(a)}
                  comboDetailOption={this.state.comboDetailOption}
                  selectedCombo={this.state.selectedCombo}
                  addProduct={(itemId) => {
                    this.addProduct(
                      this.state.productLista.find((i) => i.id == itemId),
                    );
                  }}
                  tablenoprop={this.props.tablenemeprop}
                />
              </div>
              <PosKeyboard
                getsaleOrderLine={() => this.getsaleOrderLine()}
                posStorage={this.props.posStorage}
                lang={this.props.lang}
                addProduct={(itemId) => {
                  this.addProduct(
                    this.state.productLista.find((i) => i.id == itemId),
                  );
                }}
              />
            </div>
            {/* mywork */}
            <Row gutter={12} style={{ display: "none" }}>
              <Col span={16}>
                {/* product card */}
                <Card style={{ border: "none" }}>
                  <h1
                    style={{
                      display: "none",
                      fontSize: "17px",
                      padding: "0 0",
                    }}
                  >
                    Products
                  </h1>
                  <Row gutter={12}>
                    <div
                      className="proDiv my_prodiv"
                      style={{
                        justifyContent:
                          !this.state.productList.length > 0 && "center",
                        alignItems:
                          !this.state.productList.length > 0 && "center",
                      }}
                    >
                      {this.state.productList.length > 0 ? (
                        this.state.productList.map((item, key) => (
                          <Card
                            key={item.id}
                            className="productCard"
                            loading={this.state.cardLoad}
                            onClick={() => {
                              this.props.posStorage &&
                                this.props.posStorage.orderId &&
                                this.addProduct(item);
                            }}
                            style={{
                              width: "14%",
                              height: "180px ",
                              marginTop: "10px",
                              marginLeft: "13px",
                            }}
                            cover={
                              <MyImg
                                src={`${API_URL} getProductImage?clientName=${localStorage.getItem(
                                  "client_name",
                                )}&imageName=${item.imageName}&imageContent=${
                                  item.imageContent
                                }`}
                                alt="Produc not found"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = "/default.jpg";
                                }}
                              />
                            }
                          >
                            <span className="product-class ">
                              <p
                                style={{
                                  fontSize: "Xsmall",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  fontSize: "13px",
                                  marginBottom: "0.5em",
                                  marginTop: "-1px",
                                }}
                              >
                                {" "}
                                {localStorage.getItem("lang") == "EN"
                                  ? item.name
                                  : item.nameAr}
                              </p>
                              {this.state.catTabKeyWithDelay == 1 && (
                                <p
                                  style={{
                                    fontSize: "Xsmall",
                                    fontWeight: 900,
                                    textAlign: "center",
                                    textOverflow: "ellipsis",
                                    marginTop: "-1px",
                                    marginBottom: "0.5em",
                                  }}
                                >
                                  {item.isOffer
                                    ? item.offerPriceTax
                                    : JSON.parse(
                                        localStorage.getItem("isInclusiveTax"),
                                      )
                                    ? item.price
                                    : item.priceWithoutTax}{" "}
                                </p>
                              )}
                            </span>
                          </Card>
                        ))
                      ) : (
                        <div className="noProductFound"></div>
                      )}
                    </div>
                  </Row>
                </Card>

                <Row
                  gutter={24}
                  className={
                    this.state.productCategoryList.length < 4
                      ? "categoryRow"
                      : "categoryRow2"
                  }
                  style={{ display: "none" }}
                >
                  {/* old cat sec */}
                  <Col span={24}>
                    <div className="container category_tabs">
                      <Tabs
                        defaultActiveKey={this.state.catTabKey}
                        onChange={(key) => {
                          this.setState({ catTabKey: key });
                        }}
                      >
                        <TabPane tab="Product Categories" key={1}>
                          <section className="customer-logos slider">
                            <Slider
                              className="customer-logos slider "
                              {...settings}
                            >
                              {this.state.productCategoryList1.length > 0 &&
                                this.state.productCategoryList1.map(
                                  (item, i) => (
                                    <div className="mainCatClass ">
                                      <Card
                                        key={item.id}
                                        style={{
                                          background: `url(${API_URL}getProductImage?clientName=${localStorage.getItem(
                                            "client_name",
                                          )}&imageName=${
                                            item.imageName
                                          }&imageContent=${item.imageContent})`,
                                        }}
                                        className="productCard catListTop categoryCardBody"
                                        loading={this.state.cardLoad}
                                        onClick={() => {
                                          this.props.posStorage &&
                                            this.props.posStorage.orderId &&
                                            this.categorySelected(item);
                                        }}
                                        cover={
                                          <MyImg
                                            alt="Product  not found"
                                            src={`${API_URL}getProductImage?clientName=${localStorage.getItem(
                                              "client_name",
                                            )}&imageName=${
                                              item.imageName
                                            }&imageContent=${
                                              item.imageContent
                                            }`}
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src = "/default.jpg";
                                            }}
                                          />
                                        }
                                      >
                                        <span className="product-class ">
                                          <p
                                            style={{
                                              fontSize: "Xsmall",
                                              fontWeight: 900,
                                              textAlign: "center",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                            {" "}
                                            {localStorage.getItem("lang") ==
                                            "AR"
                                              ? item.nameAr
                                              : item.name}{" "}
                                          </p>
                                        </span>
                                      </Card>
                                      {this.state.productCategoryList2.length >
                                        i && (
                                        <Card
                                          key={
                                            this.state.productCategoryList2[i]
                                              .id
                                          }
                                          style={{
                                            background: `url(${API_URL}getProductImage?clientName=${localStorage.getItem(
                                              "client_name",
                                            )}&imageName=${
                                              this.state.productCategoryList2[i]
                                                .imageName
                                            }&imageContent=${
                                              this.state.productCategoryList2[i]
                                                .imageContent
                                            })`,
                                          }}
                                          className="productCard catListBtm categoryCardBody"
                                          loading={this.state.cardLoad}
                                          onClick={() => {
                                            this.props.posStorage &&
                                              this.props.posStorage.orderId &&
                                              this.categorySelected(
                                                this.state.productCategoryList2[
                                                  i
                                                ],
                                              );
                                          }}
                                          cover={
                                            <MyImg
                                              alt="Product  not found"
                                              src={`${API_URL}getProductImage?clientName=${localStorage.getItem(
                                                "client_name",
                                              )}&imageName=${
                                                this.state.productCategoryList2[
                                                  i
                                                ].imageName
                                              }&imageContent=${
                                                this.state.productCategoryList2[
                                                  i
                                                ].imageContent
                                              }`}
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = "/default.jpg";
                                              }}
                                            />
                                          }
                                        >
                                          <span className="product-class ">
                                            <p
                                              style={{
                                                fontSize: "Xsmall",
                                                fontWeight: 900,
                                                textAlign: "center",
                                                textOverflow: "ellipsis",
                                              }}
                                            >
                                              {" "}
                                              {localStorage.getItem("lang") ==
                                              "AR"
                                                ? this.state
                                                    .productCategoryList2[i]
                                                    .nameAr
                                                : this.state
                                                    .productCategoryList2[i]
                                                    .name}
                                            </p>
                                          </span>
                                        </Card>
                                      )}
                                    </div>
                                  ),
                                )}
                            </Slider>
                          </section>
                        </TabPane>
                        {/* <TabPane tab="Combo Options" key={2}>
                                                    <section className="customer-logos slider">
                                                        <Slider className="customer-logos slider"
                                                            {...settings} >
                                                            {
                                                                this.state.comboCategotyList.length > 0 &&
                                                                this.state.comboCategotyList.map((item, i) => (

                                                                    <Card
                                                                        key={item.id}
                                                                        style={{
                                                                            background: `url(${API_URL}getProductImage?clientName=${localStorage.getItem('client_name')}&imageName=${item.imageName}&imageContent=${item.imageContent})`,
                                                                            width: '20%', height: '180px', marginTop: '10px', marginLeft: '13px'

                                                                        }}
                                                                        className="productCard"
                                                                        loading={this.state.cardLoad}
                                                                        onClick={() => { this.comboSelected(item) }}
                                                                        cover={<MyImg
                                                                            alt="Product  not found"
                                                                            src={`${API_URL}getProductImage?clientName=${localStorage.getItem('client_name')}&imageName=${item.imageName}&imageContent=${item.imageContent}`}
                                                                            onError={(e) => { e.target.onerror = null; e.target.src = "/default.jpg" }}
                                                                        />}
                                                                    >
                                                                        <span className='product-class '>
                                                                            <p style={{ fontSize: 'small', fontWeight: 650, textAlign: 'center' }}> {item.name} </p>
                                                                        </span>

                                                                    </Card>
                                                                ))

                                                            }

                                                        </Slider>
                                                    </section>
                                                </TabPane> */}
                      </Tabs>
                      {/* //Tabs Here */}
                    </div>
                  </Col>
                  {/* old cat sec */}
                </Row>
              </Col>
              <Col span={8}>
                <PosSlip
                  paymethods={this.props.paymethods}
                  paymentok={this.props.paymentok}
                  senPrintOnCancelOrder={(i) =>
                    this.props.senPrintOnCancelOrder(i)
                  }
                  // disctoun
                  isDiscount={this.props.isDiscount}
                  isDiscountP={this.props.isDiscountP}
                  disAmt={this.props.disAmt}
                  disPrctg={this.props.disPrctg}
                  // disctoun
                  lang={this.props.lang}
                  // paymentScreen={() => this.paymentScreen()}
                  ref={(ref) => (this.refPosSlip = ref)}
                  getsaleOrderLine={() => this.getsaleOrderLine()}
                  totalOrder={this.state.orderById}
                  productList={this.state.productLista}
                  posProductsLists={this.state.posProductsLists}
                  customerSelectedName={this.state.customerSelectedName}
                  language={this.props.props.language}
                  customerSelect={() => this.customerSelect()}
                  slipData={this.state.arrayAddedItems}
                  onPaymentSelect={(a) => this.onPaymentSelect(a)}
                  comboDetailOption={this.state.comboDetailOption}
                  selectedCombo={this.state.selectedCombo}
                  addProduct={(itemId) => {
                    //
                    this.addProduct(
                      this.state.productLista.find((i) => i.id == itemId),
                    );
                  }}
                />
              </Col>
            </Row>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    posStorage: state.posStorage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    posStorageAction: (payload) => dispatch(posStorageAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Pos2ChildContainer);
